import React from 'react'
import { ServicesBlocksWrapper } from './Styled'
import { useTranslation } from 'react-i18next'
import { Col, Container, Row } from 'react-bootstrap'
import ServicesListing2 from './ServicesList2'
import ServicesListing3 from './ServicesList3'
import ServicesListing1 from './ServicesList1'
import ServicesListing4 from './ServicesList4'
import ServicesListing5 from './ServicesList5'
import ServicesListing6 from './ServicesList6'
import ServicesListing7 from './ServicesList7'
import ServicesListing8 from './ServicesList8'


const ServicesBlocks = () => {
    const { t, i18n } = useTranslation();

    
    return (
        <ServicesBlocksWrapper >
            <Container >
                <Row>
                    <Container className='p-0 '>
                        <Row className='rowListingCol'>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing1 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing2 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing3 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing4 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing5 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing6 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing7 />
                            </Col>
                            <Col sm={12 } md={6} lg={4} xl={3} className='mb-4'>
                                <ServicesListing8 />
                            </Col>
                        </Row>
                    </Container>
                </Row>
            </Container >
            
        </ServicesBlocksWrapper >
    )
}

export default ServicesBlocks